import { Logger } from './Logger';
import { JWEB_SIGNIN_REQUEST_ID } from '../constants/commons';

/**
 * Cancels an active JWeb authentication request
 * @returns {Promise<any>} The result of the cancel request operation
 */
export const cancelAuthRequest = async () => {
  try {
    const cancelRequestResult = await window.JWeb.Plugins.Auth.cancelRequest({
      requestId: JWEB_SIGNIN_REQUEST_ID
    });
    Logger.log('Auth.CancelRequest result:', cancelRequestResult);
    return cancelRequestResult;
  } catch (err) {
    Logger.error('Promise rejected while calling Auth.CancelRequest.', err);
    throw err;
  }
};
